export default __webpack_public_path__ + "static/media/support.461e2919.svg";